import Vue from 'vue'
import Vuex from 'vuex'
import {login} from './_store/login.module';
import {alerts} from './_store/alerts.module';
import {images} from './_store/images.module';
import {documents} from './_store/documents.module';
import {users} from './_store/users.module';
import {lots} from './_store/lots.module';
import {blocks} from './_store/blocks.module';
import {stages} from './_store/stages.module';
import {tasks} from './_store/tasks.module';
import {houses} from './_store/houses.module';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        login,
        alerts,
        images,
        documents,
        users,
        lots,
        blocks,
        stages,
        tasks,
        houses
    }
});
